import {WidgetRegistry} from '@voltmoney/component';
import React, {useEffect} from 'react';
import {StyleSheet, useWindowDimensions, View} from 'react-native';
import {isMobile} from './configs/util';
import ThemeProvider from '@voltmoney/theme';

import {getLocalStorageSync, LocalStorageType} from './configs/localStorage';
import {ROUTE_PARTNER} from './configs/types';
import {ROUTE, ROUTE_MAP} from '@voltmoney/micro-frontend';
import {MicroFrontend} from '@voltmoney/platform';

const PartnerDashboard: React.FunctionComponent<{route: any}> = ({
  route,
}: any) => {
  /*** Get all params sent via URL ****/
  //Example-1
  //http://localhost:3000/partner/dashboard/helloworld
  // access route.params -> {params: 'helloworld'}
  //Example-2
  //http://localhost:3000/partner/dashboard?ref_code=12345
  // access route.params -> {ref_code: '12345'}

  const {width, height} = useWindowDimensions();
  let theme = ThemeProvider.getTheme();

  const routeConfig =
    route.name === ROUTE_PARTNER.SIGNUP
      ? ROUTE.PARTNER_SIGNUP
      : route.name === ROUTE_PARTNER.LEADS
      ? ROUTE.PARTNER_LEAD
      : route.name === ROUTE_PARTNER.ACTIVE_CUSTOMER
      ? ROUTE.PARTNER_ACTIVE_CUSTOMER
      : route.name === ROUTE_PARTNER.REFERRED_PARTNER
      ? ROUTE.PARTNER_REFERRED_PARTNER
      : ROUTE.PARTNER_DASHBOARD_V2;

  const _isMobile = isMobile();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const styles = StyleSheet.create({
    dashBoardContainer: {
      width: '100%',
      height: height,
      alignItems: 'center',
      backgroundColor: !_isMobile ? 'rgb(242, 242, 242)' : '#FFFFFF',
    },
  });

  return (
    <View style={styles.dashBoardContainer}>
      <View
        style={{
          width: width,
          position: 'absolute',
          height: 60,
          borderColor: 'red',
          backgroundColor: 'white',
        }}
      />
      <View
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          maxWidth: 1600,
        }}>
        <MicroFrontend
          routeMap={ROUTE_MAP}
          routeCurrent={routeConfig ? routeConfig : ROUTE.PARTNER_DASHBOARD_V2}
          widgetRegistry={WidgetRegistry}
          extraProps={{
            setIsUserLoggedIn: true,
            partnerUserContext: getLocalStorageSync(
              LocalStorageType.USER_CONTEXT,
            ),
          }}
          //@ts-ignore
          width={'100%'}
          height={height}
          isPartnerPlatform={true}
        />
      </View>
    </View>
  );
};

export default PartnerDashboard;
